import { combineReducers } from "redux";
import {UserProfile,Windowsadd} from "./Reducer";
const Reducers = combineReducers({
  UserProfile,Windowsadd
  });
  export default Reducers;